import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'fleet-sidebar-header',
  templateUrl: './sidebar-header.component.html',
  styleUrls: ['./sidebar-header.component.scss'],
})
export class SidebarHeaderComponent implements OnInit {
  @Input() title: string;
  @Output() closeSidebar = new EventEmitter();
  constructor() {}

  ngOnInit(): void {}
}
